import AccountLabel from '../AccountLabel';

const AccountsFilter = ({accounts, selectedIds, onChange}) => {
    const allIds = accounts.map(a => a.id);
    const allSelected = allIds.length > 0 && selectedIds.length === allIds.length;

    const toggle = (id) => {
        const set = new Set(selectedIds);
        set.has(id) ? set.delete(id) : set.add(id);
        onChange(Array.from(set));
    };

    if (!accounts.length) return null;

    return (
        <section className="filter-card">
            <div className="filter-card__header">
                <div className="filter-card__title">Accounts</div>
                <div className="filter-card__actions">
                    <button
                        type="button"
                        className="filter-action"
                        onClick={() => onChange(allIds)}
                        disabled={allSelected}
                        title="Select all"
                    >✓</button>
                    <button
                        type="button"
                        className="filter-action"
                        onClick={() => onChange([])}
                        disabled={!selectedIds.length}
                        title="Clear"
                    >×</button>
                </div>
            </div>
            <div className="filter-list">
                {accounts.map(a => (
                    <label key={a.id} className="filter-check">
                        <input
                            type="checkbox"
                            checked={selectedIds.includes(a.id)}
                            onChange={() => toggle(a.id)}
                        />
                        <AccountLabel account={a}/>
                    </label>
                ))}
            </div>
        </section>
    );
};

export default AccountsFilter;
